// extracted by mini-css-extract-plugin
module.exports = {"box":"MessengerItemCheckBox_box__2690e"};